<template>
  <div class="dropdown-body">
    <DropdownMenuElement @click="addRow">
      <template #icon>
        <Icon type="plus" size="16" />
      </template>
      {{ isRow ? $t('Add item') : $t('Add sub-item') }}
    </DropdownMenuElement>
    <DropdownMenuElement @click="() => addGroup(1)">
      <template #icon>
        <Icon type="plus" size="16" />
      </template>
      {{ $t('Add group') }}
    </DropdownMenuElement>
    <DropdownMenuElement
      v-if="context.rowLevel === 1 || context.rowLevel === 2"
      @click="() => convertToGroup(0)"
    >
      <template #icon>
        <Icon type="refresh" size="16" />
      </template>
      {{ $t('Convert to item') }}
    </DropdownMenuElement>
    <DropdownMenuElement @click="deleteRow">
      <template #icon>
        <Icon type="trash" size="16" />
      </template>
      {{ context.rowLevel ? $t('Delete group') : $t('Delete row') }}
    </DropdownMenuElement>
  </div>
</template>

<script>
  import DropdownMenuElement from '@/components/ui/dropdown-menu/DropdownMenuElement';
  import Icon from '@/components/ui/Icon';

  export default {
    name: 'EstimateRowContext',
    components: {
      DropdownMenuElement,
      Icon,
    },
    props: {
      context: {
        type: Object,
        default: () => ({
          allowPaste: Boolean,
          allowCopy: Boolean,
          allowComment: Boolean,
          rowLevel: Number,

          delete: Function,
          add: Function,
          addGroup: Function,
          convertToGroup: Function,
          copy: Function,
          paste: Function,
          comment: Function,
        }),
      },
    },
    computed: {
      isRow() {
        return this.context.rowLevel === 0;
      },
    },
    methods: {
      deleteRow() {
        this.context.delete?.();
        this.$emit('close');
      },
      addRow() {
        this.context.add?.();
        this.$emit('close');
      },
      addGroup(level) {
        this.context.addGroup?.(level);
        this.$emit('close');
      },
      convertToGroup(level) {
        this.context.convertToGroup?.(level);
        this.$emit('close');
      },
      copy() {
        this.context.copy?.();
        this.$emit('close');
      },
      paste() {
        this.context.paste?.();
        this.$emit('close');
      },
      comment() {
        this.context.comment?.({
          pageX: this.context.pageX,
          pageY: this.context.pageY,
        });
      },
    },
  };
</script>
